import styled from "styled-components";
import images from "../images";
import { DESKTOP_MEDIA_QUERY } from "../constants";

export const Wrapper = styled.div`
  padding: 21px 23px;
`;

export const StepTitle = styled.div`
  margin: 0 23px 26px;
  font-size: 16px;
  font-weight: 600;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 48px;
  }
`;

export const DossierWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Card = styled.div`
  position: relative;
  width: 225px;
  height: 290px;
  padding: 120px 19px 0;
  border: 2px solid #ff0000;
  background-color: #e6e6e6;

  &:before {
    content: "";
    display: block;

    position: absolute;
    top: -2px;
    right: -2px;

    width: 22px;
    height: 24px;
    background-color: #fff;
    background-image: url(${images.dossier_corner.src});
    background-size: contain;
  }

  &:after {
    content: "";
    display: block;

    position: absolute;
    top: -14px;
    left: 20px;

    width: 116px;
    height: 103px;

    background-image: url(${images.dossier_pin.src});
    background-size: contain;
  }

  ${DESKTOP_MEDIA_QUERY} {
    width: 390px;
    height: 400px;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #ff0000;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 32px;
  }
`;

export const Description = styled.div`
  margin-top: 17px;
  font-size: 10px;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 18px;
  }
`;

export const Pic = styled.div`
  position: absolute;
  top: 0;
  left: 23px;

  width: 82px;
  height: 87px;

  background-image: url(${({ id }) => images[`dossier_character_${id}`].src});
  background-size: cover;

  z-index: 10;
`;

export const ArrowRight = styled.div`
  width: 13px;
  height: 23px;

  margin: 0 12px;

  background-image: url(${images.dossier_arrow.src});
  background-size: cover;

  cursor: pointer;
`;

export const ArrowLeft = styled(ArrowRight)`
  transform: rotate(180deg);
`;

export const DotsWrapper = styled.div`
  width: 100%;

  margin: 12px 0;

  display: flex;
  justify-content: center;
`;

export const Dot = styled.div`
  width: 10px;
  height: 10px;

  margin: 0 4px;

  border: 2px solid #ff0000;
  border-radius: 50%;

  background-color: ${({ active }) => (active ? "#FF0000" : "#fff")};
`;
